"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = void 0;
/**
 * @internal
 * Groups values in an array
 * @param src The source array which needs to be grouped
 * @param keySelector A function to select the key value to group by
 * @param valueSelector A function to select the value that will be stored in the group
 * @returns An array of groups that were found
 */
function groupBy(src, keySelector, valueSelector) {
    if (typeof src === "undefined" || src === null) {
        throw new Error("src must be an array");
    }
    return src.reduce(function (pv, cv) {
        var objKey = keySelector(cv);
        var objVal = valueSelector(cv);
        var foundGroup = pv.find(function (x) { return x.key == objKey; });
        if (foundGroup) {
            foundGroup.values.push(objVal);
            return pv;
        }
        else {
            var newGroup = { key: objKey, values: [objVal] };
            return __spreadArrays(pv, [newGroup]);
        }
    }, []);
}
exports.groupBy = groupBy;
